import { useEffect, useState, useContext } from "react";
import { formatDistanceStrict } from "date-fns";

import useApi from "../hooks/useApi";
import usersApi from "../api/users";
import UsersContext from "../context/usersContext";

const useUsers = () => {
    const { users, setUsers } = useContext(UsersContext);
    const [usersLoading, setUsersLoading] = useState();
    const getUsersApi = useApi(usersApi.getUsers);
    const addSubscriptionApi = useApi(usersApi.addSubscription);
    const removeSubscriptionApi = useApi(usersApi.removeSubscription);

    useEffect(() => {
        loadUsers();
    }, []);

    const loadUsers = async () => {
        console.log("Loading users started");
        setUsersLoading(true);

        const response = await getUsersApi.request();
        if (!response.ok) {
            setUsersLoading(false);
            return;
        }

        setUsers(response.data);
        setUsersLoading(false);
        console.log("Loading users finished");
    };

    const addSubscription = async (userID, subscription) => {
        const result = await addSubscriptionApi.request(userID, subscription);
        if (result.ok) {
            let userToUpdate;

            userToUpdate = users.findIndex((x) => x._id == userID);
            if (userToUpdate >= 0) {
                users[userToUpdate].subscriptions.push(subscription);
                setUsers(users);
            }
        }
    };

    const removeSubscription = async (userID, subscription) => {
        const result = await removeSubscriptionApi.request(userID, subscription);
        if (result.ok) {
            let userToUpdate;
            let subscriptionToUpdate;

            userToUpdate = users.findIndex((x) => x._id == userID);
            subscriptionToUpdate = users[userToUpdate].subscriptions.findIndex((x) => x == subscription);
            if (userToUpdate >= 0) {
                users[userToUpdate].subscriptions.splice(subscriptionToUpdate, 1);
                setUsers(users);
            }
        }
    };

    return {
        users,
        setUsers,
        usersLoading,
        loadUsers,
        addSubscription,
        removeSubscription,
        addSubscription,
    };
};

export default useUsers;
